import React from "react";

const surveyData = [
    {
        "step": 0,
        "type": 1,
        "title": "Financial Reporting Oversight Role 질문지",
        "treeTitle": "FROR 질문지",
        "questions": [
            "감사법인의 독립성 규정에 따른 잠재적인 용역 제한",
            "(Potential Service Limitations Due to Independence Rules for Audit Firms)",
            "미국 증권거래위원회(SEC)가 제정한 Financial Reporting Oversight Role (FROR) 규정에 의하면 회계감사법인인 Ernst & Young과 고객사간 감사관계가 존재할 경우 개인에 대한 세무자문 서비스 제공이 금지될 수 있습니다.",
            "Financial Reporting Oversight Role (FROR) 규정은 미국에서 발효되었으나 수범 대상자에 해당 개인 뿐만 아니라 그 직계가족까지 포함되므로 전 세계에 영향을 미칠 수 있습니다. 따라서, 직계가족이 Ernst & Young에서 감사하는 미국 증권거래위원회(SEC) 상장회사의 중대한 역할을 수행할 가능성이 있으므로 FROR 규정은 미국과 직접적으로 연관이 없는 개인에 대해서도 적용될 수 있습니다.",
            "재무제표의 내용이나 재무제표 작성자에게 영향력을 행사할 수 있는 역할을 Financial Reporting Oversight Role (FROR)이라고 지칭합니다. 재무제표의 내용이나 재무제표 작성자에게 영향력을 행사할 수 있는 위치에 있는 사람의 예시는 다음과 같습니다.",
            "최고 경영자(CEO), 사장, 최고 재무담당책임자(CFO), 최고 업무집행책임자(COO), 고문 변호사, 최고 회계 책임자, 회계 담당자, 내부감사 책임자, 재무보고, 재무 및 세무 이사 또는 이와 동등한 지위 등이 FROR 에 해당됩니다. 또한 공개기업의 재무제표 및 미국 증권거래위원회 보고에 포함되어있는 관련 정보를 작성하는 사람들을 감독하는 직접적인 책임을 지는 개인도 FROR에 포함됩니다.",
            "따라서 귀하 또는 귀하의 직계가족이 (직계가족은 귀하의 배우자 또는 그와 동등한 관계에 있는 사람과 부양가족을 의미함) 미국 증권거래위원회 상장회사의 재무제표의 내용이나 재무제표 작성자에게 영향력을 행사할 수 있는 위치에 있는지 확인하고자 하오니，만일 해당사항이 있다면 YES 박스를 체크하신 후 Summary Sheet 상의 정보를 기입하시기 바랍니다. 만약 귀하나 직계가족이 FROR에 해당하지 않으면 NO 박스를 체크하시고 Summary Sheet는 무시하시기 바랍니다.",
            "Ernst & Young 은 주기적으로 귀하와 귀하의 직계가족의 FROR 여부에 대해 확인을 요청드릴 것입니다. 위 내용을 확인하고 서명한 이후 귀하 또는 귀하의 직계가족의 직위변화로 인하여 FROR에 해당된다면, Ernst & Young 담당자에게 알려주시기 바랍니다."
        ],
        "text": [
            {
                "key": "1",
                "content": "본인이나 본인의 직계가족이 미국 증권거래위원회 상장회사의 재무제표의 내용이나 작성자에게 중대한 영향력을 행사할 수 있는 위치에 해당되지 않습니다.",
                "toggle": true
            },
            {
                "key": "0",
                "content": "미국 증권거래위원회 상장회사의 재무제표의 내용이나 작성자에게 중대한 영향력을 행사할 수 있는 위치에 해당됩니다(선택하시는 경우, 종합소득세 서비스 진행이 불가합니다. 다만, 회사와 정확한 정보확인을 위해 아래 추가정보를 기입해 주십시오.)",
                "toggle": false
            }
        ],
        "column": "frorAgreeYn",
        "answer": "",
        "rel": [
            1,
            2,
            3,
            4
        ],
        "hide": false
    },
    {
        "step": 1,
        "type": 1,
        "title": "Name of FROR Individual :",
        "treeTitle": "Name of FROR Individual",
        "questions": [],
        "text": [],
        "column": "frorIndividual",
        "maxLength": 100,
        "answer": "",
        "hide": true
    },
    {
        "step": 2,
        "type": 1,
        "title": "Relationship :",
        "treeTitle": "Relationship",
        "questions": [],
        "text": [
            {
                "key": "HC035001",
                "content": "Self"
            },
            {
                "key": "HC035002",
                "content": "Spouse / Spouse Equivalent"
            },
            {
                "key": "HC035003",
                "content": "Dependent"
            }
        ],
        "column": "frorRlspGcd",
        "answer": "",
        "hide": true
    },
    {
        "step": 3,
        "type": 1,
        "title": "Job Head of FROR Individual :",
        "treeTitle": "Job Head of FROR Individual",
        "questions": [],
        "text": [],
        "column": "frorJobTitle",
        "maxLength": 100,
        "answer": "",
        "hide": true
    },
    {
        "step": 4,
        "type": 1,
        "title": "Name of Company where FROR performs services :",
        "treeTitle": "Name of Company where FROR performs services",
        "questions": [],
        "text": [],
        "column": "frorCorpNm",
        "maxLength": 100,
        "answer": "",
        "hide": true
    },
    {
        "step": 5,
        "type": 1,
        "title": "1) 귀하의 성명을 입력하세요.",
        "treeTitle": "1 - 1) 성명",
        "questions": [],
        "text": [],
        "column": "userNm",
        "maxLength": 30,
        "answer": "",
        "hide": false
    },
    {
        "step": 6,
        "type": "title",
        "title": "1. 개인정보",
        "treeTitle": "",
        "questions": [],
        "text": [],
        "column": "",
        "answer": ""
    },
    {
        "step": 7,
        "type": 1,
        "title": "2) 귀하의 국적은 한국(대한민국) 입니까?",
        "treeTitle": "1 - 2) 한국 여부",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예",
                "toggle": true
            },
            {
                "key": "0",
                "content": "아니오",
                "toggle": false
            }
        ],
        "column": "IS_KOR",
        "answer": "",
        "rel": [
            8
        ],
        "hide": false
    },
    {
        "step": 8,
        "type": "nation",
        "title": "국적을 입력하세요.",
        "treeTitle": "1 - 2) 국적",
        "questions": [],
        "text": [],
        "column": "natlGcd",
        "answer": "",
        "hide": true
    },
    {
        "step": 9,
        "type": 1,
        "title": "4) $stdYear$년 12월 31일 기준 배우자 유무를 확인해주세요.",
        "treeTitle": "1 - 3~5) 주민등록등본 상 정보",
        "questions": [],
        "text": [
            {
                "key": "미혼",
                "content": "미혼"
            },
            {
                "key": "기혼",
                "content": "기혼"
            },
            {
                "key": "사별",
                "content": "사별"
            },
            {
                "key": "이혼",
                "content": "이혼"
            }
        ],
        "column": "spouse",
        "answer": "",
        "hide": false
    },
    {
        "step": 10,
        "type": 1,
        "title": "6) 연락 가능한 전화번호를 입력하세요. ※ - 없이 입력(예: 01012345678)",
        "treeTitle": "1 - 6) 전화번호",
        "questions": [],
        "text": [],
        "column": "telNo",
        "answer": "",
        "hide": false
    },
    {
        "step": 11,
        "type": 1,
        "title": "7) 파견정보에 대하여 기재해 주십시오.",
        "treeTitle": "1 - 7) 파견정보",
        "questions": [],
        "text": [],
        "column": "dsptNatGcd",
        "answer": "",
        "hide": false
    },
    {
        "step": 12,
        "type": 1,
        "title": "8) 사원번호를 입력하세요.",
        "treeTitle": "1 - 8) 사원번호",
        "questions": [],
        "text": [],
        "column": "empNo",
        "maxLength": 20,
        "answer": "",
        "hide": false
    },
    {
        "step": 13,
        "type": 1,
        "title": "9) 회사 이메일을 입력하세요.",
        "treeTitle": "1 - 9) 회사 이메일",
        "questions": [],
        "text": [],
        "column": "email",
        "inputType": "email",
        "answer": "",
        "hide": false
    },
    {
        "step": 14,
        "type": "title",
        "title": "2. 배우자 및 부양가족 정보 (기본공제대상자)",
        "treeTitle": "",
        "questions": [
            "종합소득(이자, 배당, 사업, 근로, 연금 및 기타)소득 양도소득, 퇴직소득 등의 소득금액 합계액이 100만원(근로소득만 있는 자는 총급여 500만원)을 초과한 부양가족에 대해서는 기본공제 및 특별소득공제· 특별세액공제를 받을 수 없습니다.",
            "한국 세법상 근로자이거나 소득이 있는 자는 개별적으로 세무신고를 해야할 의무가 있습니다."
        ],
        "text": [],
        "column": "",
        "answer": "",
        "hide": false
    },
    {
        "step": 15,
        "type": 1,
        "title": "1) $stdYear$년도 귀속 종합소득세 신고 시 인적공제 금액을 반영하시고자 하는 배우자 및 부양가족 정보를 작성하여 주시기 바랍니다.",
        "treeTitle": "2 - 1) 부양가족 상세 정보 제출 여부",
        "questions": [
            "해당 질문지를 통해 부양가족 정보를 제공해 주시지 않은 경우, 종합소득세 및 세액보전정산 시 부양가족 관련 공제를 받을 수 없는 점 유의 부탁드립니다.",
            `※ 회사에서 귀하의 부양가족 정보를 보유하고 있더라도 $stdYear$년 귀속 연말정산을 신고하지 않은 경우(혹은 연말정산을 신고한 경우에도 부양가족 공제가 반영되지 않은 경우) EY에서는 관련 정보를 수령할 수 없습니다.`,
            "<span style='font-weight: bold;'>$stdYear$년 귀속 연말정산</span><sub>(2026년 3월 10일 신고 기한)</sub><span style='font-weight: bold;'>원천징수영수증</span>을 확인하시고 적절하게 답변 부탁드립니다.",
            "<span style='font-weight: bold;'>부양가족이 장애가 있는 경우,</span> 장애인 증명서를 <a href='/survey#112' style='color: #26A9E3; padding-left: 6px; font-weight: bold'>질문 4-10</a>을 통해 제출해주시기 바랍니다. 관련 증명이 없는 경우 장애인 추가공제(1명당 연200만원)는 반영되지 않는 점 안내드립니다."
        ],
        "text": [
            {
                "key": "0",
                "content": " 2025년도 귀속 연말정산을 진행하였고, 연말정산의 부양가족 정보로 동일하게 반영하기를 원함.",
                "toggle": true
            },
            {
                "key": "1",
                "content": " 2025년도 귀속 연말정산을 진행하지 않았거나, 추가/삭제되어야 할 부양가족이 있어 새로 부양가족 정보를 작성하기를 원함.",
                "toggle": false
            }
        ],
        "column": "familyAplyYn",
        "answer": "",
        "rel": [
            16
        ],
        "hide": false
    },
    {
        "step": 16,
        "type": 3,
        "title": "2 - 2) 부양가족으로 신청하실 가족정보를 입력하세요.",
        "treeTitle": "2 -2) 부양가족 정보 입력",
        "questions": [],
        "text": [],
        "column": "FAMILY_INPUT_YN",
        "answer": "",
        "hide": true
    },
    {
        "step": 17,
        "type": "title",
        "title": "3. 개인소득 정보",
        "treeTitle": "",
        "questions": [],
        "text": [],
        "column": "",
        "answer": "",
        "hide": false
    },
    {
        "step": 18,
        "type": 1,
        "title": " 1) $stdYear$년 중 <u class=\"title-underline-deco\">국내·외에서 수령한 이자 및 배당소득</u> 합계가 연간 2천만원을 초과합니까?",
        "treeTitle": "3 - 1) 국내 이자/배당소득",
        "questions": [
            "참고로, 국내외 이자배당소득의 합계가 2천만원 이하인 경우, 국내 이자/배당소득은 원천징수로 신고의무가 종료되므로 종합소득세 신고의무가 면제됩니다. 동일한 경우더라도 국외 이자/배당소득은 반드시 종합소득세 신고를 통해 신고되어야 합니다.",
            "<div style='margin-top: 10px'>이자소득 - 금융기관에 예금한 금액(적금·부금·예탁금과 우편대체를 포함)의 이자, 그 외 금전을 대여하고 지급받은 이자 등",
            "배당소득 - 법인으로부터 받는 이익이나 잉여금의 배당 또는 분배금, 집합투자기구(펀드 등)로부터의 이익 등. 주식보상소득의 취득에 따른 이익은 배당소득이 아님 (예: 스톡옵션을 행사하는 경우)",
            "<div style='margin-top: 10px'>신고되어야 할 국내 이자/배당소득이 있는 경우 2026년 5월 홈택스에서 이자 및 배당소득 내역을 다운로드하여 EY한영 담당자에게 추가로 이메일을 통해 전달하여 주시기 바랍니다.",
            "2천만원 초과하는 개인소득자료 다운로드 방법 <a target=\"_blank\" href=\"/pdf/홈택스 가이드 - 이자배당 자료 받기.pdf\">PDF 링크</a>"
        ],
        "text": [
            {
                "key": "1",
                "content": "예 (초과합니다)"
            },
            {
                "key": "0",
                "content": "아니오 (초과하지 않습니다)"
            }
        ],
        "column": "intDiviYn",
        "answer": "",
        "hide": false
    },
    {
        "step": 19,
        "type": 1,
        "title": " 2) $stdYear$년 중 <u class=\"title-underline-deco\">국외에서 수령한 이자/배당소득</u>이 있습니까?",
        "treeTitle": "3 - 2) 국외 이자/배당소득",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예 (있습니다)"
            },
            {
                "key": "0",
                "content": "아니오 (없습니다)"
            }
        ],
        "column": "intYn",
        "answer": "",
        "hide": false
    },
    {
        "step": 20,
        "type": 1,
        "title": " 3) 임대소득이 있습니까? <a target=\"_blank\" href=\"https://www.nts.go.kr/nts/cm/cntnts/cntntsView.do?mi=2251&cntntsId=7682\">(임대소득 과세기준 참고자료)</a>",
        "treeTitle": "3 - 3) 임대소득",
        "questions": [
            "* 유의 : 주택 임대소득의 의 경우 주택 수 및 월세/ 전세에 따른 과세 기준은 아래와 같습니다.  아래 기준에 따라 과세 대상인 주택 임대 소득에 해당 하는지 판단 하시어 답변 해 주십시오.",
            "< 판단기준 >",
            "1. 1주택자 : 비과세, 단 기준시가 9억 초과 및 국외 소재 주택의 월세는 과세",
            "2. 2주택자 : 월세에 대하여 과세",
            "3. 3주택자 이상 : 월세 및 간주임대료득 (전세 보증금 합계액이 3억을 초과하는 부분에 대한 일정 비율) 에 대해 과세, 단 2022년도 까지 전용면적 40㎡ 이하 이면서 기준시가가 2억 원 이하인 ‘소형주택’에 대해서는 간주 임대료 제외"
        ],
        "text": [
            {
                "key": "1",
                "content": "예",
                "toggle": false
            },
            {
                "key": "0",
                "content": "아니오",
                "toggle": true
            }
        ],
        "column": "rentYn",
        "answer": "",
        "rel": [
            21,
            22,
            23,
            24,
            25,
            26,
            27,
            121,
            122,
            123,
        ],
        "hide": false
    },
    {
        "step": 21,
        "type": 1,
        "title": "3 - 1) $stdYear$년 중 소유한 주택 및 상가는 총 몇 채 입니까? <a target=\"_blank\" href=\"/images/rent_desc_2.png\">(주택의 정의 및 주택수 계산 참고자료)</a>",
        "treeTitle": "소유 주택 및 상가",
        "questions": [],
        "text": [],
        "column": "houseCnt",
        "answer": "",
        "hide": true
    },
    {
        "step": 22,
        "type": 1,
        "title": " 3 - 2) $stdYear$년 중 본인이 단독 또는 공동명의로 소유하였던 주택에 대한 정보를 입력하세요.<div>(배우자 100% 등 본인 명의 없는 건은 제외, 건별 입력 필수)</div>",
        "treeTitle": "주택 정보 입력",
        "questions": [],
        "text": [],
        "column": "",
        "answer": "",
        "hide": true
    },
    {
        "step": 23,
        "type": 1,
        "title": "3 - 3) $stdYear$년 중 본인이 단독 또는 공동명의로 소유하였던 상가에 대한 정보를 입력하세요.<div>(배우자 100% 등 본인 명의 없는 건은 제외, 건별 입력 필수)</div>",
        "treeTitle": "상가 정보 입력",
        "questions": [],
        "text": [],
        "column": "",
        "answer": "",
        "hide": true
    },
    {
        "step": 24,
        "type": 1,
        "title": "3 - 4) 직전년도(2024년) 사업소득(부동산 임대소득 포함) 총 금액을 입력하세요. (신규사업자의 경우 0원 기재)",
        "treeTitle": "직전년도 사업소득",
        "questions": [
            "금액은 필요경비 차감 전 총 수입금액을 기재해 주시기 바랍니다."
        ],
        "text": [],
        "column": "preBizAmt",
        "answer": "",
        "hide": true
    },
    {
        "step": 25,
        "type": 1,
        "title": "3 - 5) $stdYear$년도 납부하신 중간예납세액을 입력 부탁드립니다. (납부하지 않은 경우 0원 기재)",
        "treeTitle": "중간예납세액",
        "questions": [],
        "text": [],
        "column": "midPrepAmt",
        "answer": "",
        "hide": true
    },
    {
        "step": 26,
        "type": 1,
        "title": "3 - 6) [착한 임대인 세액 공제] 및 [상가건물 장기임대사업자에 대한 세액감면] 대상자입니까? <a href='/survey#27' style='color: #26A9E3; padding-left: 6px'>3-7 이동</a>",
        "treeTitle": "기타임대세액공제 대상자",
        "questions": [
            "EY는 해당 공제/세액감면을 받을 수 있는 요건을 모두 만족하였는지에 대한 사실여부를 판단하지 않습니다.",
            "요건 위배로 확인되는 경우 과다 공제된 세액에 대한 책임은 개인에게 있습니다.",
            "해당 공제/감면을 적용하기 위한 서류를 <a href='/survey#27' style='color: #26A9E3; padding-left: 6px; font-weight: bold'>질문3-7</a>을 통해 제출 부탁드립니다.",
            "관련 서류가 부족한 경우 관련 공제를 받을 수 없는 점 유의 부탁드립니다."
        ],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "optRentYn",
        "answer": "",
        "hide": true
    },
    {
        "step": 27,
        "type": "file",
        "title": "3 - 7) 임대소득 관련 첨부파일을 업로드 부탁드립니다. (개인세무사 정보를 전달해주신 경우, 별도 업로드 해주시지 않으셔도 됩니다)",
        "treeTitle": "임대소득 관련자료 첨부",
        "questions": [
           "<a target=\"_blank\" href=\"/pdf/홈택스 가이드 - 부가가치세 신고서 받기.pdf\">홈택스에서 신고한 부가가치세 신고서 다운로드 방법</a>",
           "<a target=\"_blank\" href=\"/pdf/홈택스 가이드 - 신고도움자료 받기.pdf\">종합소득세 신고 안내문 다운로드 방법</a>",
        ],
        "text": [],
        "column": "rentFileUpload",
        "answer": "",
        "hide": true
    },
    {
        "step": 28,
        "type": 1,
        "title": "4) $stdYear$년 중 사업소득이 있습니까?",
        "treeTitle": "3 - 4) 사업소득",
        "questions": [
            "예) 개인사업자로서 농업, 제조업, 금융업 등의 사업에서 발생한 소득",
            "[첨부파일 예시]",
            `1) 2025년도 귀속 1기 2기 부가가치세 신고서 사본 (국세청 다운로드시 정보 공개여부 "여"로 체크 필요)`,
            "2) 사업자등록증",
            "3) 공동사업자 소득분배명세서 (해당하는 경우)",
            "4) 중간예납 납부영수증 (납부한 경우)",
            "5) 종합소득세 신고 안내문 (선택사항)",
            "6) 간편장부 소득금액계산서, 총수입금액 및 필요경비명세서(간편장부를 작성한 경우)",
            "7) 총수입금액조정명세서, 조정후총수입금액명세서, 조정계산서, 과목별 소득금액조정명세서, 소득금액조정합계표, 표준합계잔액시산표, 표준손익계산서, 표준재무상태표(복식부기를 작성한 경우)",
            "<br/> 파일형식 : 이미지파일(*.jpg, *.png), PDF파일, Office문서(*.xlsx, *.docx), ZIP파일"
        ],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "bizYn",
        "answer": "",
        "hide": false
    },
    {
        "step": 29,
        "type": 1,
        "title": "5) 위의 열거된 소득 외의 기타소득이 있습니까?",
        "treeTitle": "3 - 5) 기타소득",
        "questions": [
            "예) 일시적 인적용역으로 인한 소득(예: 강연료), 상금, 포상금, 부동산 계약 배상금 등",
            "파일형식 : 이미지파일(*.jpg, *.png), PDF파일, Office문서(*.xlsx, *.docx), ZIP파일"
        ],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "etcYn",
        "answer": "",
        "hide": false
    },
    {
        "step": 30,
        "type": "title",
        "title": "4. 공제 정보",
        "treeTitle": "",
        "questions": [
            "다음의 질문은 공제 중 요건이 복잡한",
            "주택자금 소득공제 / 장기집합투자증권저축 납입액 소득공제 / 월세액 세액공제",
            "관련하여 요건만족여부를 확인하기 위함입니다.",
            "관련 공제대상금액이 있는 경우 \"예\"로 답변하시고 세부 질문에 답변해주시기 바랍니다.",
            "제출해주신 내용을 토대로 공제 요건 만족여부를 판단하고 공제를 반영하므로 정확한 확인 후 작성하셔야 하는 점 유념하여 주시면 감사하겠습니다."
        ],
        "text": [],
        "column": "",
        "answer": "",
        "hide": false
    },
    {
        "step": 31,
        "type": 1,
        "title": "1) 주택임차차입금 원리금상환액 소득공제 관련 공제금액이 있습니까?(전세자금대출, 임차보증금대출 등)",
        "treeTitle": "4 - 1) 주택임차차입금 원리금상환액 소득공제 관련 공제금액",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_31",
        "answer": "",
        "hide": false,
        "mailColumnNm": "4 - 1) 주택임차차입금 원리금상환액 소득공제"
    },
    {
        "step": 32,
        "type": 2,
        "title": "1 - 1)  $stdYear$년 12월 31일 기준, 근로자 본인은 세대주입니까?<a href='/survey#9' style='color: #26A9E3; padding-left: 6px'>수정하기</a>",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오 (개인정보 세대주 여부를 따름)"
            }
        ],
        "column": "step_32",
        "answer": "",
        "hide": false,
        "mailColumnNm": "2025년 12월 31일 기준 본인이 세대주임"
    },
    {
        "step": 33,
        "type": 3,
        "title": "가)   $stdYear$년 귀속 연말정산 또는 종합소득세 신고에서 동일 세대의 세대주가 주택자금공제 / 주택마련저축소득공제 / 월세액 세액공제 중 어느 하나라도 받습니까?",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예, 받습니다."
            },
            {
                "key": "0",
                "content": "아니오, 공제를 받지 않습니다."
            }
        ],
        "column": "step_33",
        "answer": "",
        "hide": false,
        "visible": {
            "column": "step_32",
            "value": "0"
        },
        "mailColumnNm": "동일세대의 세대주가 주택자금공제/주택마련저축소득공제/월세액세액공제를 적용받음"
    },
    {
        "step": 34,
        "type": 3,
        "title": "나)   $stdYear$년 귀속 연말정산 또는 종합소득세 신고에서 동일세대의 구성원이 주택자금공제 / 주택마련저축소득공제 / 월세액세액공제 중 어느 하나라도 받습니까?",
        "treeTitle": "",
        "questions": [
            "세대의 구성원이란? 배우자, 본인과 같은 주소 또는 거소에서 생계를 같이 하는 거주자와 그 배우자의 직계존비속(그 배우자를 포함) 및 형제자매"
        ],
        "text": [
            {
                "key": "1",
                "content": "예, 받습니다."
            },
            {
                "key": "0",
                "content": "아니오, 공제를 받지 않습니다."
            }
        ],
        "column": "step_34",
        "answer": "",
        "hide": false,
        "visible": {
            "column": "step_33",
            "value": "0"
        },
        "mailColumnNm": "동일세대의 구성원이 주택자금공제/주택마련저축소득공제/월세액세액공제 적용받음"
    },
    {
        "step": 35,
        "type": 2,
        "title": "1 - 2)  $stdYear$년 12월 31일 기준, 근로자 본인을 포함한 세대구성원이 주택을 소유하고 있습니까?",
        "treeTitle": "",
        "questions": [
            "다음의 경우에는 세대구성원이 주택을 소유하고 있는 것으로 판단되니 참고하시어 답변 부탁드립니다.",
            "• 세대분리된 배우자가 주택을 소유하고 있는 경우 (배우자는 세대분리된 상황에도 세대 구성원으로 판단)",
            "• 공동명의로 주택을 소유하고 있는 경우",
            "• 상속주택을 공동소유하고 있으며 상속지분이 가장 큰 상속인에 해당하는 경우(상속지분이 가장 큰 상속인이 2인 이상이라면 상속인들 중 상속주택에 거주하는 사람이 없고 해당 상속인이 최연장자에 해당하는 경우)"
        ],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_35",
        "answer": "",
        "hide": false,
        "mailColumnNm": "2025년 12월 31일 기준 본인 또는 세대구성원이 주택을 1주택 이상 소유하고 있음"
    },
    {
        "step": 36,
        "type": 2,
        "title": "1 - 3)  관련 임대차 계약은 근로자 본인의 명의(100%)로 작성하였습니까?",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예, 본인의 명의로 작성함"
            },
            {
                "key": "0",
                "content": "아니오, 본인이 아닌 자의 명의(또는 공동명의)로 작성함"
            }
        ],
        "column": "step_36",
        "answer": "",
        "hide": false,
        "mailColumnNm": "관련 임대차 계약은 본인명의(100%)의 계약임"
    },
    {
        "step": 37,
        "type": 2,
        "title": "1 - 4)  관련 임차한 물건(주택)은 주택법 상 주택이거나 주거용 오피스텔입니까?",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_37",
        "answer": "",
        "hide": false,
        "mailColumnNm": "관련 임대 물건이 주택법상 주택/주거용 오피스텔에 해당함"
    },
    {
        "step": 38,
        "type": 2,
        "title": "1 - 5)  관련 임차한 물건(주택)의 주거전용면적은 국민주택규모 이하입니까?<br/>(국민주택규모 = 주거전용면적 85㎡ (25평) 이하, 수도권을 제외한 도심지역이 아닌 읍 또는 면지역은 100㎡이하)",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_38",
        "answer": "",
        "hide": false,
        "mailColumnNm": "관련 임대 물건의 주거전용면적이 국민주택규모(85㎡) 이하에 해당함"
    },
    {
        "step": 39,
        "type": 2,
        "title": "1 - 6)  연말정산 간소화자료 상 조회된 원리금 상환액 또는 이자비용 납입액은 근로자 본인 명의 (100%) 의 주택임차차입금에 대한 금액입니까?",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_39",
        "answer": "",
        "hide": false,
        "mailColumnNm": "관련 금전소비대차(대출) 계약은 본인명의(100%)의 계약임"
    },
    {
        "step": 40,
        "type": 2,
        "title": "1 - 7)  주택임차차입금의 차입일은 2008년 1월 1일 이후입니까?",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_40",
        "answer": "",
        "hide": false,
        "mailColumnNm": "관련 금전소비대차(대출) 계약의 차입일이 2008년 1월 1일 이후임"
    },
    {
        "step": 41,
        "type": 2,
        "title": "1 - 8)  관련 주택임차차입금은 어디서 차입한 금액입니까?",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "국내 대출기관",
                "content": "국내 대출기관"
            },
            {
                "key": "대부업 등을 경영하지 아니하는 거주자",
                "content": "대부업 등을 경영하지 아니하는 거주자"
            },
            {
                "key": "그 외",
                "content": "그 외"
            }
        ],
        "column": "step_41",
        "answer": "",
        "hide": false,
        "mailColumnNm": "관련 금전소비대차(대출) 계약의 채권자 유형"
    },
    {
        "step": 42,
        "type": 3,
        "title": "가)  금전소비대차계약서 상 차입일이 임대차계약서 상 입주일과 주민등록표 등본의 전입일 중 빠른 날로부터 전후 3개월 이내입니까?(임대차계약을 연장/갱신하면서 차입한 경우, 계약 연장일/갱신일로부터 전후 3개월 이내)",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_42",
        "answer": "",
        "hide": false,
        "visible": {
            "column": "step_41",
            "value": "국내 대출기관"
        },
        "mailColumnNm": "관련 금전소비대차(대출) 계약의 차입일이 입주일/전입일(또는 연장/갱신일)로부터 전후 3개월 이내에 해당함"
    },
    {
        "step": 43,
        "type": 3,
        "title": "나)  차입금은 대출기관에서 임대인의 계좌로 직접 입금되었습니까?",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_43",
        "answer": "",
        "hide": false,
        "visible": {
            "column": "step_41",
            "value": "국내 대출기관"
        },
        "mailColumnNm": "관련 금전소비대차(대출) 계약 관련 차입금을 금융기관에서 임대인 계좌로 직접 입금함"
    },
    {
        "step": 44,
        "type": 3,
        "title": "가)  금전소비대차계약서 상 차입일이 임대차계약서 상 입주일과 주민등록표 등본의 전입일 중 빠른 날로부터 전후 1개월 이내입니까?(임대차계약을 연장/갱신하면서 차입한 경우, 계약 연장일/갱신일로부터 전후 1개월 이내)",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_44",
        "answer": "",
        "hide": false,
        "visible": {
            "column": "step_41",
            "value": "대부업 등을 경영하지 아니하는 거주자"
        },
        "mailColumnNm": "관련 금전소비대차(대출) 계약의 차입일이 입주일/전입일(또는 연장/갱신일)로부터 전후 1개월 이내에 해당함"
    },
    {
        "step": 45,
        "type": 3,
        "title": "나)  금전소비대차계약서 상 이자율은 다음의 기준이율 이상입니까?",
        "treeTitle": "",
        "questions": [
            "• 2014.3.15.이후 차입분 : 연 2.9%",
            "• 2015.3.13.이후 차입분 : 연 2.5%",
            "• 2016.3.16.이후 차입분 : 연 1.8%",
            "• 2017.3.10.이후 차입분 : 연 1.6%",
            "• 2018.3.21.이후 차입분 : 연 1.8%",
            "• 2019.3.20.이후 차입분 : 연 2.1%",
            "• 2020.3.13.이후 차입분 : 연 1.8%",
            "• 2021.3.16.이후 차입분 : 연 1.2%",
            "• 2023.3.20.이후 차입분 : 연 2.9%",
            "• 2024.3.22.이후 차입분 : 연 3.1%"
        ],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_45",
        "answer": "",
        "hide": false,
        "visible": {
            "column": "step_41",
            "value": "대부업 등을 경영하지 아니하는 거주자"
        },
        "mailColumnNm": "관련 금전소비대차(대출) 계약의 차입이율이 공제요건 상 기준이율 이상임"
    },
    {
        "step": 46,
        "type": 2,
        "title": "1 - 9)   $stdYear$년 연 중 다른 주택 또는 주거용 오피스텔로 이주하였습니까?",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_46",
        "answer": "",
        "hide": false,
        "mailColumnNm": "2025년 중 거주지 이주 여부"
    },
    {
        "step": 47,
        "type": 3,
        "title": "가)  이주 전 임차주택 및 이주한(현재) 임차주택 관련 주택임대차계약 및 주택임차차입금 금전소비대차계약에 대한 사항은 위 공제 관련 3 ~ 8 질문에 대한 답변과 동일합니까??",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_47",
        "answer": "",
        "hide": false,
        "visible": {
            "column": "step_46",
            "value": "1"
        },
        "mailColumnNm": "이주 전 임차주택 및 현재 임차주택 관련 주택임대차계약 및 금전소비대차(대출)계약 사항은 위 답변한 내용과 동일함"
    },
    {
        "step": 48,
        "type": 3,
        "title": "나)  위 공제 관련 3~8 질문에 대한 답변은 어떤 주택에 대한 주택임차차입금 관련하여 작성하였습니까?",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "이전 임차주택에 대한 주택임차차입금",
                "content": "이전 임차주택에 대한 주택임차차입금"
            },
            {
                "key": "현재 임차 중인 임차주택에 대한 주택임차차입금",
                "content": "현재 임차 중인 임차주택에 대한 주택임차차입금"
            }
        ],
        "column": "step_48",
        "answer": "",
        "hide": false,
        "visible": {
            "column": "step_47",
            "value": "0"
        },
        "mailColumnNm": "위 답변 사항 관련 주택"
    },
    {
        "step": 49,
        "type": 3,
        "title": "다)  다른 주택에 대한 주택임차차입금 공제 요건 판단을 위해 답변을 기재해주십시오.",
        "treeTitle": "",
        "questions": [],
        "text": [],
        "column": "",
        "answer": "",
        "hide": false,
        "visible": {
            "column": "step_47",
            "value": "0"
        },
    },
    {
        "step": 50,
        "type": 4,
        "title": "다 - 1)  임대차 계약은 근로자 본인의 명의로 작성하였습니까?",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예, 본인의 명의로 작성함"
            },
            {
                "key": "0",
                "content": "아니오, 본인이 아닌 자의 명의(또는 공동명의)로 작성함"
            }
        ],
        "column": "step_50",
        "answer": "",
        "hide": false,
        "visible": {
            "column": "step_47",
            "value": "0"
        },
        "mailColumnNm": "관련 임대차 계약은 본인명의(100%)의 계약임"
    },
    {
        "step": 51,
        "type": 4,
        "title": "다 - 2)   임대주택은 주택법 상 주택이거나 주거용 오피스텔입니까?",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_51",
        "answer": "",
        "hide": false,
        "visible": {
            "column": "step_47",
            "value": "0"
        },
        "mailColumnNm": "관련 임대 물건이 주택법상 주택/주거용 오피스텔에 해당함"
    },
    {
        "step": 52,
        "type": 4,
        "title": "다 - 3)   임대주택의 주거전용면적은 국민주택규모 이하입니까? (국민주택규모 = 주거전용면적 85㎡ (25평) 이하)",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_52",
        "answer": "",
        "hide": false,
        "visible": {
            "column": "step_47",
            "value": "0"
        },
        "mailColumnNm": "관련 임대 물건의 주거전용면적이 국민주택규모(85㎡) 이하에 해당함"
    },
    {
        "step": 53,
        "type": 4,
        "title": "다 - 4)   상환한 원리금 또는 납입한 이자비용은 근로자 본인 명의의 주택임차차입금 관련 금액입니까?",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_53",
        "answer": "",
        "hide": false,
        "visible": {
            "column": "step_47",
            "value": "0"
        },
        "mailColumnNm": "관련 금전소비대차(대출) 계약은 본인명의(100%)의 계약임"
    },
    {
        "step": 54,
        "type": 4,
        "title": "다 - 5)   주택임차차입금의 차입일은 2008년 1월 1일 이후입니까?",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_54",
        "answer": "",
        "hide": false,
        "visible": {
            "column": "step_47",
            "value": "0"
        },
        "mailColumnNm": "관련 금전소비대차(대출) 계약의 차입일이 2008년 1월 1일 이후임"
    },
    {
        "step": 55,
        "type": 4,
        "title": "다 - 6)   어디서 차입한 금액입니까?",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "국내 대출기관",
                "content": "국내 대출기관"
            },
            {
                "key": "대부업 등을 경영하지 아니하는 거주자",
                "content": "대부업 등을 경영하지 아니하는 거주자"
            },
            {
                "key": "그 외",
                "content": "그 외"
            }
        ],
        "column": "step_55",
        "answer": "",
        "hide": false,
        "visible": {
            "column": "step_47",
            "value": "0"
        },
        "mailColumnNm": "관련 금전소비대차(대출) 계약의 채권자 유형"
    },
    {
        "step": 56,
        "type": 5,
        "title": "가)  금전소비대차계약서 상 차입일이 임대차계약서 상 입주일과 주민등록표 등본의 전입일 중 빠른 날로부터 전후 3개월 이내입니까?(임대차계약을 연장/갱신하면서 차입한 경우, 계약 연장일/갱신일로부터 전후 3개월 이내)",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_56",
        "answer": "",
        "hide": false,
        "visible": {
            "column": "step_55",
            "value": "국내 대출기관"
        },
        "mailColumnNm": "관련 금전소비대차(대출) 계약의 차입일이 입주일/전입일(또는 연장/갱신일)로부터 전후 3개월 이내에 해당함"
    },
    {
        "step": 57,
        "type": 5,
        "title": "나)  차입금은 대출기관에서 입대인의 계좌로 직접 입금되었습니까?",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_57",
        "answer": "",
        "hide": false,
        "visible": {
            "column": "step_55",
            "value": "국내 대출기관"
        },
        "mailColumnNm": "관련 금전소비대차(대출) 계약 관련 차입금을 금융기관에서 임대인 계좌로 직접 입금함"
    },
    {
        "step": 58,
        "type": 5,
        "title": "가)  금전소비대차계약서 상 차입일이 임대차계약서 상 입주일과 주민등록표 등본의 전입일 중 빠른 날로부터 전후 1개월 이내입니까?(임대차계약을 연장/갱신하면서 차입한 경우, 계약 연장일/갱신일로부터 전후 1개월 이내)",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_58",
        "answer": "",
        "hide": false,
        "visible": {
            "column": "step_55",
            "value": "대부업 등을 경영하지 아니하는 거주자"
        },
        "mailColumnNm": "관련 금전소비대차(대출) 계약의 차입일이 입주일/전입일(또는 연장/갱신일)로부터 전후 1개월 이내에 해당함"
    },
    {
        "step": 59,
        "type": 5,
        "title": "나)  금전소비대차계약서 상 이자율은 다음의 기준이율 이상입니까?",
        "treeTitle": "",
        "questions": [
            "• 2014.3.15.이후 차입분 : 연 2.9%",
            "• 2015.3.13.이후 차입분 : 연 2.5%",
            "• 2016.3.16.이후 차입분 : 연 1.8%",
            "• 2017.3.10.이후 차입분 : 연 1.6%",
            "• 2018.3.21.이후 차입분 : 연 1.8%",
            "• 2019.3.20.이후 차입분 : 연 2.1%",
            "• 2020.3.13.이후 차입분 : 연 1.8%",
            "• 2021.3.16.이후 차입분 : 연 1.2%",
            "• 2023.3.20.이후 차입분 : 연 2.9%",
            "• 2024.3.22.이후 차입분 : 연 3.1%"
        ],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_59",
        "answer": "",
        "hide": false,
        "visible": {
            "column": "step_55",
            "value": "대부업 등을 경영하지 아니하는 거주자"
        },
        "mailColumnNm": "관련 금전소비대차(대출) 계약의 차입이율이 공제요건 상 기준이율 이상임"
    },
    {
        "step": 60,
        "type": 1,
        "title": "2) 장기주택저당차입금 이자 소득공제 관련 공제금액이 있습니까? ",
        "treeTitle": "4 - 2) 장기주택저당차입금 이자줕 소득공제 관련 공제금액",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_60",
        "answer": "",
        "hide": false,
        "mailColumnNm": "4 - 2) 장기주택저당차입금 이자 소득공제"
    },
    {
        "step": 61,
        "type": 2,
        "title": "2 - 1)  $stdYear$년 12월 31일 기준, 근로자 본인은 세대주입니까?<a href='/survey#9' style='color: #26A9E3; padding-left: 6px'>수정하기</a>",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오 (개인정보 세대주 여부를 따름)"
            }
        ],
        "column": "step_61",
        "answer": "",
        "hide": false,
        "mailColumnNm": "2025년 12월 31일 기준 본인이 세대주임"
    },
    {
        "step": 62,
        "type": 3,
        "title": "나)  $stdYear$년 귀속 연말정산 또는 종합소득세 신고에서 동일 세대의 세대주가 주택자금공제 / 주택마련저축소득공제 / 월세액세액공제 중 어느 하나라도 받습니까?",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예, 받습니다."
            },
            {
                "key": "0",
                "content": "아니오, 공제를 받지 않습니다."
            }
        ],
        "column": "step_62",
        "answer": "",
        "hide": false,
        "visible": {
            "column": "step_126",
            "value": "1"
        },
        "mailColumnNm": "동일세대의 세대주가 주택자금공제/주택마련저축소득공제/월세액세액공제를 적용받음"
    },
    {
        "step": 63,
        "type": 3,
        "title": "다)   $stdYear$년 귀속 연말정산 또는 종합소득세 신고에서 동일세대의 구성원이 주택자금공제 / 주택마련저축소득공제 / 월세액세액공제 중 어느 하나라도 받습니까?",
        "treeTitle": "",
        "questions": [
            "세대의 구성원이란? 배우자, 본인과 같은 주소 또는 거소에서 생계를 같이 하는 거주자와 그 배우자의 직계존비속(그 배우자를 포함) 및 형제자매"
        ],
        "text": [
            {
                "key": "1",
                "content": "예, 받습니다."
            },
            {
                "key": "0",
                "content": "아니오, 공제를 받지 않습니다."
            }
        ],
        "column": "step_63",
        "answer": "",
        "hide": false,
        "visible": {
            "column": "step_62",
            "value": "0"
        },
        "mailColumnNm": "동일세대의 구성원이 주택자금공제/주택마련저축소득공제/월세액세액공제를 적용받음"
    },
    {
        "step": 64,
        "type": 2,
        "title": "2 - 2)   $stdYear$년 12월 31일 기준, 근로자 본인을 포함한 세대구성원이 소유한 주택의 합계가 2주택 이상입니까?",
        "treeTitle": "",
        "questions": [
            "다음의 경우에는 세대구성원이 주택을 소유하고 있는 것으로 판단되니 참고하시어 답변 부탁드립니다.",
            "• 세대분리된 배우자가 주택을 소유하고 있는 경우(배우자는 세대분리된 상황에도 세대 구성원으로 판단)",
            "• 공동명의로 주택을 소유하고 있는 경우",
            "• 상속주택을 공동소유하고 있으며 상속지분이 가장 큰 상속인에 해당하는 경우(상속지분이 가장 큰 상속인이 2인 이상이라면 상속인들 중 상속주택에 거주하는 사람이 없고 해당 상속인이 최연장자에 해당하는 경우)"
        ],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_64",
        "answer": "",
        "hide": false,
        "mailColumnNm": "2025년 12월 31일 기준 본인 또는 세대구성원이 주택을 2주택 이상 소유하고 있음"
    },
    {
        "step": 65,
        "type": 2,
        "title": "2 - 3)  금전소비대차(대출) 최초 계약시, 근로자 본인 명의의 주택을 담보로 하여 본인의 명의로 차입한 금액입니까?<br/>(공동명의 주택 포함, 본인이 반드시 주택에 대한 소유지분이 있고, 금전소비대차의 차입자에 해당해야 함)",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_65",
        "answer": "",
        "hide": false,
        "mailColumnNm": "관련 금전소비대차(대출) 계약은 본인명의(100%)의 물건을 담보로 본인명의(100%)로 한 계약임"
    },
    {
        "step": 66,
        "type": 2,
        "title": "2 - 4)  금전소비대차계약서 상 차입일이 2006년 1월 1일 이후입니까?",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_66",
        "answer": "",
        "hide": false,
        "mailColumnNm": "관련 금전소비대차(대출) 계약의 차입일이 2006년 1월 1일 이후임"
    },
    {
        "step": 67,
        "type": 2,
        "title": "2 - 5)  금전소비대차계약서 상 차입일은 주택소유권이전등기 또는 (보존)등기일로부터 3개월 이내입니까?",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_67",
        "answer": "",
        "hide": false,
        "mailColumnNm": "관련 금전소비대차(대출) 계약의 차입일이 주택소유권이전등기/(보존)등기일로부터 3개월 이내에 해당함"
    },
    {
        "step": 68,
        "type": 2,
        "title": "2 - 6)  금전소비대차계약서 상 차입금의 상환기간은 다음의 기준기간 이상입니까?",
        "treeTitle": "",
        "questions": [
            "• 2003년 12월 31일 이전 차입금: 10년",
            "• 2014년 12월 31일 이전 차입금: 15년",
            "• 2015년 1월 1일 이후 차입금: 10년"
        ],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_68",
        "answer": "",
        "hide": false,
        "mailColumnNm": "관련 금전소비대차(대출) 계약의 상환기간이 공제 요건 기준기간 이상임"
    },
    {
        "step": 69,
        "type": 2,
        "title": "2 - 7)  금전소비대차계약서 상 담보 주택은 주택법 상 주택(오피스텔 제외)입니까?",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_69",
        "answer": "",
        "hide": false,
        "mailColumnNm": "관련 담보 물건은 주택법상 주택/주거용 오피스텔에 해당함"
    },
    {
        "step": 70,
        "type": 2,
        "title": "2 - 8)  금전소비대차계약서 상 담보 주택의 주거전용면적은 국민주택규모 이하입니까?<br/>(국민주택규모 = 주거전용면적 85㎡ (25평) 이하, 수도권을 제외한 도시지역이 아닌 읍 또는 면지역은 100㎡이하)",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_70",
        "answer": "",
        "hide": false,
        "mailColumnNm": "관련 담보 물건의 주거전용면적이 국민주택규모(85㎡) 이하에 해당함"
    },
    {
        "step": 71,
        "type": 2,
        "title": "2 - 9)  금전소비대차계약서 상 담보 주택의 취득시점 기준시가는 다음의 기준금액 이하입니까?",
        "treeTitle": "",
        "questions": [
            "• 2013년 12월 31일 이전 차입금: 3억원",
            "• 2014년 1월 1일 이후 차입금: 4억원",
            "• 2019년 1월 1일 이후 차입금: 5억원",
            "• 2024년 1월 1일 이후 차입금: 6억원",
            "• 기준시가 확인방법 : <a target=\"_blank\" href=\"https://www.realtyprice.kr\">부동산공시가격알리미</a>"
        ],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_71",
        "answer": "",
        "hide": false,
        "mailColumnNm": "관련 담보 물건의 취득시점 기준시가가 공제 요건 기준금액 이하임"
    },
    {
        "step": 72,
        "type": 2,
        "title": "2 - 10)   $stdYear$년 중 장기주택차입금 대출기관 또는 대출상품을 변경하였습니까?",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_72",
        "answer": "",
        "hide": false,
        "mailColumnNm": "2025년 중 장기주택차입금 대출기관 또는 대출상품의 변경 여부"
    },
    {
        "step": 73,
        "type": 3,
        "title": "가)  대출금액이 변동되었습니까?",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_73",
        "answer": "",
        "hide": false,
        "visible": {
            "column": "step_72",
            "value": "1"
        },
        "mailColumnNm": "2025년 중 금전소비대차(대출) 계약 상 대출금액 변동 여부"
    },
    {
        "step": 74,
        "type": 3,
        "title": "나)  변경된 대출금액을 기재해주시기 바랍니다.",
        "treeTitle": "",
        "questions": [],
        "text": [],
        "column": "step_74",
        "answer": "",
        "hide": false,
        "visible": {
            "column": "step_73",
            "value": "1"
        },
        "mailColumnNm": "변경된 대출금액"
    },
    {
        "step": 75,
        "type": 1,
        "title": "3) 청약저축 납입액 소득공제 관련 공제금액이 있습니까? ",
        "treeTitle": "4 - 3) 청약저축 납입액 소득공제 관련 공제금액",
        "questions": [
            "해당 공제는 총급여 7,000만원 이하의 근로자만 받을 수 있습니다.",
            "＊ 청약저축과 주택청약종합저축은 다른 공제이므로 확인하시고 답변하시기 바랍니다."
        ],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_75",
        "answer": "",
        "hide": false,
        "mailColumnNm": "4 - 3) 청약저축 납입액 소득공제"
    },
    {
        "step": 76,
        "type": 2,
        "title": "3 - 1)  근로자 본인 명의의 저축에 납입한 금액입니까?",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_76",
        "answer": "",
        "hide": false,
        "mailColumnNm": "본인 명의의 저축임"
    },
    {
        "step": 77,
        "type": 2,
        "title": "3 - 2)  $stdYear$년 12월 31일 기준, 근로자 본인은 세대주입니까?<a href='/survey#9' style='color: #26A9E3; padding-left: 6px'>수정하기</a>",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오 (개인정보 세대주 여부를 따름)"
            }
        ],
        "column": "step_77",
        "answer": "",
        "hide": false,
        "mailColumnNm": "2025년 12월 31일 기준 본인이 세대주임"
    },
    {
        "step": 78,
        "type": 2,
        "title": "3 - 3)   $stdYear$년 중 근로자 본인 또는 세대구성원이 주택을 소유한 적이 있습니까?",
        "treeTitle": "",
        "questions": [
            "다음의 경우에는 세대구성원이 주택을 소유하고 있는 것으로 판단되니 참고하시어 답변 부탁드립니다.",
            "• 세대분리된 배우자가 주택을 소유하고 있는 경우 (배우자는 세대분리된 상황에도 세대 구성원으로 판단)",
            "• 공동명의로 주택을 소유하고 있는 경우",
            "• 상속주택을 공동소유하고 있으며 상속지분이 가장 큰 상속인에 해당하는 경우(상속지분이 가장 큰 상속인이 2인 이상이라면 상속인들 중 상속주택에 거주하는 사람이 없고 해당 상속인이 최연장자에 해당하는 경우)"
        ],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_78",
        "answer": "",
        "hide": false,
        "mailColumnNm": "2025년 중 본인 또는 동일세대구성원이 주택을 소유한 적 있음"
    },
    {
        "step": 79,
        "type": 2,
        "title": "3 - 4)  2010년 1월 1일 이후 가입한 저축입니까?",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_79",
        "answer": "",
        "hide": false,
        "mailColumnNm": "동 저축을 2010년 1월 1일 이후 가입하였음"
    },
    {
        "step": 80,
        "type": 2,
        "title": "3 - 5)  근로자 본인은 다음의 어느 하나에 해당합니까?",
        "treeTitle": "",
        "questions": [
            "<span style='font-weight: bold;'>Case1)</span> 2025년 중 1개 이하의 주택을 소유한 적 있으나, 관련 주택은 청약저축 가입 당시 보유하고 있었던 국민주택규모<sup>*</sup>의 주택으로서 가입당시 기준시가가 3억원 이하에 해당함",
            "<span style='font-weight: bold;'>Case2)</span> 2025년 중 1개 이하의 주택을 소유한 적 있으나, 관련 주택은 청약저축 가입 후 취득한 국민주택규모<sup>*</sup>의 주택으로서 취득 당시 주택의 기준시가가 3억원 이하에 해당",
            "* 국민주택규모 = 주거전용면적 85㎡ (25평) 이하, 수도권을 제외한 도시지역이 아닌 읍 또는 면지역은 100㎡ 이하"
        ],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_80",
        "answer": "",
        "hide": false,
        "mailColumnNm": "본인은 2025년 중 1개 이하의 주택을 소유한 적 있으나 공제요건을 만족함"
    },
    {
        "step": 81,
        "type": 1,
        "title": "4) 주택청약종합저축 납입액 소득공제 관련 공제금액이 있습니까? ",
        "treeTitle": "4 - 4) 기타 주택청약종합저축 공제금액",
        "questions": [
            "해당 공제는 총급여액 7,000만원 이하인 근로소득자*만 받을 수 있습니다.",
            " ＊ 직전 3개연도 중 1회 이상 금융소득종합과세 대상자 제외"
        ],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_81",
        "answer": "",
        "hide": false,
        "mailColumnNm": "4 - 4) 주택청약종합저축 납입액 소득공제"
    },
    {
        "step": 82,
        "type": 2,
        "title": "4 - 1)  근로자 본인 명의의 저축에 납입한 금액입니까?",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_82",
        "answer": "",
        "hide": false,
        "mailColumnNm": "본인 명의의 저축임"
    },
    {
        "step": 83,
        "type": 2,
        "title": "4 - 2)  $stdYear$년 12월 31일 기준, 근로자 본인은 세대주입니까?<a href='/survey#9' style='color: #26A9E3; padding-left: 6px'>수정하기</a>",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오 (개인정보 세대주 여부를 따름)"
            }
        ],
        "column": "step_83",
        "answer": "",
        "hide": false,
        "mailColumnNm": "2025년 12월 31일 기준 본인이 세대주임"
    },
    {
        "step": 84,
        "type": 2,
        "title": "4 - 3)  $stdYear$년 중 근로자 본인 또는 세대구성원이 주택을 소유한 적이 있습니까?",
        "treeTitle": "",
        "questions": [
            "다음의 경우에는 세대구성원이 주택을 소유하고 있는 것으로 판단되니 참고하시어 답변 부탁드립니다.",
            "• 세대분리된 배우자가 주택을 소유하고 있는 경우 (배우자는 세대분리된 상황에도 세대 구성원으로 판단)",
            "• 공동명의로 주택을 소유하고 있는 경우",
            "• 상속주택을 공동소유하고 있으며 상속지분이 가장 큰 상속인에 해당하는 경우 (상속지분이 가장 큰 상속인이 2인 이상이라면 상속인들 중 상속주택에 거주하는 사람이 없고 해당 상속인이 최연장자에 해당하는 경우)"
        ],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_84",
        "answer": "",
        "hide": false,
        "mailColumnNm": "2025년 중 본인 또는 동일세대구성원이 주택을 소유한 적 있음"
    },
    {
        "step": 85,
        "type": 2,
        "title": "4 - 4)  2026년 2월말까지 저축기관에 무주택확인서를 제출하였나요?<div style='color: #777; font-weight: normal; font-size: 16px; padding-left: 45px;'>(단, 무주택확인서는 1회 제출에 한하며 매년 제출할 필요는 없음) 동일한 저축에 대하여 1회라도 제출한 경우 \"예\"로 입력</div>",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_85",
        "answer": "",
        "hide": false,
        "mailColumnNm": "동 공제를 위해 공제과세기간 다음연도 2월말까지 저축기관에 무주택확인서를 제출하였음"
    },
    {
        "step": 86,
        "type": 1,
        "title": "5) 투자조합 출자 등에 대한 소득공제 관련 공제금액이 있습니까? <a href='/survey#112' style='color: #26A9E3; padding-left: 6px'>질문10 이동</a>",
        "treeTitle": "4 - 5) 투자조합 출자 공제금액",
        "questions": [
            "다음의 서류를 <a href='/survey#112' style='color: #26A9E3; padding-left: 6px; font-weight: bold'>질문10</a>에 모두 업로드 부탁드립니다.",
            "• 출자 등 소득공제 신청서",
            "• 출자 또는 투자 확인서"
        ],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_86",
        "answer": "",
        "hide": false,
        "mailColumnNm": "4 - 5) 투자조합 출자 등에 대한 소득공제 관련 공제금액"
    },
    {
        "step": 87,
        "type": 1,
        "title": "6) 장기집합투자증권저축 납입액에 대한 소득공제 관련 공제금액이 있습니까? ",
        "treeTitle": "4 - 6) 장기집합투자증권저축 공제금액",
        "questions": ["해당 공제는 총급여 8,000만원 이하의 근로자만 받을 수 있습니다."],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_87",
        "answer": "",
        "hide": false,
        "mailColumnNm": "4 - 6)장기집합투자증권저축 납입액 소득공제"
    },
    {
        "step": 88,
        "type": 2,
        "title": "6 - 1) 2015년 12월 31일 이전에 본인 명의로 가입한 장기집합투자증권저축에 납입한 금액입니까?",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_88",
        "answer": "",
        "hide": false,
        "mailColumnNm": "동 장기집한투자증권저축을 2015년 12월 31일 이전에 가입하였음"
    },
    {
        "step": 89,
        "type": 2,
        "title": "6 - 2)  가입 당시 본인의 직전 과세기간의 총급여액이 5천만원 이하입니까?",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_89",
        "answer": "",
        "hide": false,
        "mailColumnNm": "동 저축의 가입 당시, 직전 과세기간의 총 급여액이 5천만원 이하임"
    },
    {
        "step": 90,
        "type": 2,
        "title": "6 - 3)  가입 당시 본인의 직전 과세기간의 종합소득이 있었습니까 (근로소득 및 종합소득과세표준에 합산되지 않는 종합소득 제외)?",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_90",
        "answer": "",
        "hide": false,
        "mailColumnNm": "동 저축의 가입 당시, 직전 과세기간의 종합소득금액이 있었음(근로소득 및 종합소득과세표준 미합산 종합소득 제외)"
    },
    {
        "step": 91,
        "type": 2,
        "title": "6 - 4)  해당 저축은 자산총액의 40% 이상을 국내에서 발행되어 국내에서 거래되는 주식(증권시장에 상장된 것으로 한정)에 투자하는 「소득세법」 제17조 제1항 제5호에 따른 집합투자 기구의 집합투자증권 취득을 위한 저축입니까?",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_91",
        "answer": "",
        "hide": false,
        "mailColumnNm": "동 저축을 통해 취득하는 집합투자증권은 공제요건을 만족함"
    },
    {
        "step": 92,
        "type": 2,
        "title": "6 - 5)  해당 저축은 적립식 저축입니까?",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_92",
        "answer": "",
        "hide": false,
        "mailColumnNm": "동 저축은 적립식 저축임"
    },
    {
        "step": 93,
        "type": 2,
        "title": `6 - 6)  $stdYear$년 중, 보유한 전체 장기집합투자증권저축 (청년형 저축 포함) 에 납입한 총 금액은 600만원 이하입니까?`,
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_93",
        "answer": "",
        "hide": false,
        "mailColumnNm": "2025년 중, 보유한 장기집합투자증권저축(청년형 포함)에 납입한 총 금액은 600만원 이하임"
    },
    {
        "step": 94,
        "type": 2,
        "title": "6 - 7)  저축가입일부터 10년 미만의 기간 내에 원금·이자·배당·주식 또는 수익증권 등의 인출이 있었습니까?",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_94",
        "answer": "",
        "hide": false,
        "mailColumnNm": "동 저축 가입일로부터 10년 미만의 기간 내에 원금·이자·배당·주식 또는 수익증권 등의 인출이 있었음"
    },
    {
        "step": 95,
        "type": 1,
        "title": "7) 청년형 장기집합투자증권저축 납입액에 대한 소득공제 관련 공제금액이 있습니까? ",
        "treeTitle": "4 - 7) 청년형 장기집합투자증권저축 공제금액",
        "questions": [
            "해당 공제는 총급여 8,000만원(근로소득 외 다른 종합소득이 있는 경우 종합소득금액 6,700만원)이하의 근로자만 받을 수 있습니다."
        ],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_95",
        "answer": "",
        "hide": false,
        "mailColumnNm": "4 - 7) 청년형 장기집합투자증권저축 납입액 소득공제"
    },
    {
        "step": 96,
        "type": 2,
        "title": "7 - 1)  가입 당시 직전 과세기간의 총급여액이 5천만원 이하(근로소득 외 과세표준에 합산되는 다른 종합소득이 있는 경우 해당 종합소득이 3,800만원 이하)였습니까?",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_96",
        "answer": "",
        "hide": false,
        "mailColumnNm": "동 저축의 가입 당시, 직전 과세기간의 소득이 공제요건 상 기준금액 이하임"
    },
    {
        "step": 97,
        "type": 2,
        "title": "7 - 2)  해당 저축은 자산총액의 40% 이상을 국내에서 발행되어 국내에서 거래되는 주식(증권시장에 상장된 것으로 한정)에 투자하는 「소득세법」 제17조 제1항 제5호에 따른 집합투자 기구의 집합투자증권 취득을 위한 저축입니까?",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_97",
        "answer": "",
        "hide": false,
        "mailColumnNm": "동 저축을 통해 취득하는 집합투자증권은 공제요건을 만족함"
    },
    {
        "step": 98,
        "type": 2,
        "title": "7 - 3)  해당 저축은 적립식 저축입니까?",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_98",
        "answer": "",
        "hide": false,
        "mailColumnNm": "동 저축은 적립식 저축임"
    },
    {
        "step": 99,
        "type": 2,
        "title": "7 - 4)  해당 저축의 계약기간은 3년 이상 5년 이하입니까?",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_99",
        "answer": "",
        "hide": false,
        "mailColumnNm": "동 저축의 계약기간은 공제요건을 만족함"
    },
    {
        "step": 100,
        "type": 2,
        "title": "7 - 5)  $stdYear$년 중, 보유한 전체 장기집합투자증권저축(청년형이 아닌 저축 포함)에 $stdYear$년 중 납입한 총 금액은 600만원 이하입니까?",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_100",
        "answer": "",
        "hide": false,
        "mailColumnNm": "2025년 중, 보유한 장기집합투자증권저축(청년형이 아닌 저축 포함)에 납입한 총 금액은 600만원 이하임"
    },
    {
        "step": 101,
        "type": 1,
        "title": "8) 월세액 세액공제 관련 공제금액이 있습니까? ",
        "treeTitle": "4 - 8) 월세액 세액공제 공제금액",
        "questions": [
            "해당 공제는 총급여 8,000만원(근로소득 외 다른 종합소득이 있는 경우 종합소득금액 7,000만원)이하의 근로자만 받을 수 있습니다."
        ],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_101",
        "answer": "",
        "hide": false,
        "mailColumnNm": "4 - 8) 월세액 세액공제"
    },
    {
        "step": 102,
        "type": 2,
        "title": "8 - 1)  $stdYear$년 12월 31일 기준, 근로자 본인은 세대주입니까?<a href='/survey#9' style='color: #26A9E3; padding-left: 6px'>수정하기</a>",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오 (개인정보 세대주 여부를 따름)"
            }
        ],
        "column": "step_102",
        "answer": "",
        "hide": false,
        "mailColumnNm": "2025년 12월 31일 기준 본인이 세대주임"
    },
    {
        "step": 103,
        "type": 3,
        "title": "가)  $stdYear$년 귀속 연말정산 또는 종합소득세 신고에서 동일 세대의 세대주가 주택자금공제 / 주택마련저축소득공제 / 월세액세액공제 중 어느 하나라도 받습니까?",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예, 받습니다."
            },
            {
                "key": "0",
                "content": "아니오, 공제를 받지 않습니다."
            }
        ],
        "column": "step_103",
        "answer": "",
        "hide": false,
        "visible": {
            "column": "step_102",
            "value": "0"
        },
        "mailColumnNm": "동일세대의 세대주가 주택자금공제/주택마련저축소득공제/월세액세액공제를 적용받음"
    },
    {
        "step": 104,
        "type": 3,
        "title": "나)  $stdYear$년 귀속 연말정산 또는 종합소득세 신고에서 동일세대의 구성원이 주택자금공제 / 주택마련저축소득공제 / 월세액세액공제 중 어느 하나라도 받습니까?",
        "treeTitle": "",
        "questions": [
            "세대의 구성원이란? 배우자, 본인과 같은 주소 또는 거소에서 생계를 같이 하는 거주자와 그 배우자의 직계존비속(그 배우자를 포함) 및 형제자매"
        ],
        "text": [
            {
                "key": "1",
                "content": "예, 받습니다."
            },
            {
                "key": "0",
                "content": "아니오, 공제를 받지 않습니다."
            }
        ],
        "column": "step_104",
        "answer": "",
        "hide": false,
        "visible": {
            "column": "step_103",
            "value": "0"
        },
        "mailColumnNm": "동일세대의 구성원이 주택자금공제/주택마련저축소득공제/월세액세액공제를 적용받음"
    },
    {
        "step": 105,
        "type": 2,
        "title": "8 - 2)  $stdYear$년 12월 31일 기준, 근로자 본인을 포함한 세대구성원이 주택을 소유하고 있습니까?",
        "treeTitle": "",
        "questions": [
            "다음의 경우에는 세대구성원이 주택을 소유하고 있는 것으로 판단되니 참고하시어 답변 부탁드립니다",
            "• 세대분리된 배우자가 주택을 소유하고 있는 경우 (배우자는 세대분리된 상황에도 세대 구성원으로 판단)",
            "• 공동명의로 주택을 소유하고 있는 경우",
            "• 상속주택을 공동소유하고 있으며 상속지분이 가장 큰 상속인에 해당하는 경우(상속지분이 가장 큰 상속인이 2인 이상이라면 상속인들 중 상속주택에 거주하는 사람이 없고 해당 상속인이 최연장자에 해당하는 경우)"
        ],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_105",
        "answer": "",
        "hide": false,
        "mailColumnNm": "2025년 12월 31일 기준 본인 또는 세대구성원이 주택을 1주택 이상 소유하고 있음"
    },
    {
        "step": 106,
        "type": 2,
        "title": "8 - 3)  관련 임대차 계약서는 근로자 본인 또는 본인의 기본공제대상자 명의로 작성하였습니까?",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예."
            },
            {
                "key": "0",
                "content": "아니오."
            }
        ],
        "column": "step_106",
        "answer": "",
        "hide": false,
        "mailColumnNm": "관련 임대차 계약은 본인 명의 또는 본인의 기본공제대상자 명의의 계약임"
    },
    {
        "step": 107,
        "type": 2,
        "title": "8 - 4)  관련 임대주택은 주택법 상 주택 / 주거용 오피스텔 / 고시원에 해당합니까?",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예."
            },
            {
                "key": "0",
                "content": "아니오."
            }
        ],
        "column": "step_107",
        "answer": "",
        "hide": false,
        "mailColumnNm": "관련 임대 물건이 주택법상 주택/주거용 오피스텔/고시원에 해당함"
    },
    {
        "step": 108,
        "type": 2,
        "title": "8 - 5)  관련 임대주택의 주거전용면적은 국민주택규모 이하입니까?<br/>(국민주택규모 = 주거전용면적 85㎡ (25평) 이하, 수도권을 제외한 도시지역이 아닌 읍 또는 면지역은 100㎡이하)",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예."
            },
            {
                "key": "0",
                "content": "아니오."
            }
        ],
        "column": "step_108",
        "answer": "",
        "hide": false,
        "mailColumnNm": "관련 임대 물건의 주거전용면적이 국민주택규모(85㎡) 이하에 해당함"
    },
    {
        "step": 109,
        "type": 2,
        "title": "8 - 6)  $stdYear$년 12월 31일 기준, 임대주택의 기준시가는 4억원 이하입니까?",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예."
            },
            {
                "key": "0",
                "content": "아니오."
            }
        ],
        "column": "step_109",
        "answer": "",
        "hide": false,
        "mailColumnNm": "2025년 12월 31일 기준, 관련 임대 물건의 기준시가는 4억원 이하임"
    },
    {
        "step": 110,
        "type": 2,
        "title": "8 - 7)  본인의 주민등록등본 상 주소지는 임대차 계약서 상 임대주택의 주소지와 동일합니까?",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예."
            },
            {
                "key": "0",
                "content": "아니오."
            }
        ],
        "column": "step_110",
        "answer": "",
        "hide": false,
        "mailColumnNm": "본인의 주민등록등본 상 주소지는 임대차 계약서 상 임대주택의 주소지와 동일함"
    },
    {
        "step": 111,
        "type": "file",
        "title": "9) 국세청 연말정산 간소화 소득공제자료를 업로드 부탁드립니다.",
        "treeTitle": "4 - 9) 연말정산 간소화자료 첨부",
        "questions": [],
        "text": [],
        "column": "fileUrl",
        "answer": "",
        "hide": false,
    },
    {
        "step": 112,
        "type": "file",
        "title": " 10) 국세청 간소화 자료 외 기타 공제자료를 업로드 부탁드립니다.",
        "treeTitle": "4 - 10) 기타 공제자료 첨부",
        "questions": [],
        "text": [],
        "column": "etcFileUpload",
        "answer": "",
        "hide": false,
    },
    {
        "step": 113,
        "type": "title",
        "title": "5. 환급계좌 정보",
        "treeTitle": "",
        "questions": [
            "종합소득세 신고로 인하여 환급이 발생하는 경우, 환급받으실 본인명의의 환급계좌번호를 기재해 주십시오.",
            "환급금 귀속여부는 별도 안내해드릴 예정입니다."
        ],
        "text": [],
        "column": "",
        "answer": "",
        "hide": false,
    },
    {
        "step": 114,
        "type": "bank",
        "title": " 1) 환급 은행을 선택하세요.",
        "treeTitle": "5 - 1) 환급은행",
        "questions": [],
        "text": [],
        "column": "rtnBankGcd",
        "answer": "",
        "hide": false,
        "mailColumnNm": "환급 은행"
    },
    {
        "step": 115,
        "type": 1,
        "title": " 2) 환급 계좌번호를 입력하세요.",
        "treeTitle": "5 - 2) 환급계좌",
        "questions": [],
        "text": [],
        "column": "accNo",
        "answer": "",
        "hide": false,
        "mailColumnNm": "환급 계좌번호"
    },
    {
        "step": 116,
        "type": 2,
        "title": "4 - 1) 사별/이혼한 날짜를 입력해주십시오.",
        "treeTitle": "사별/이혼한 날짜",
        "questions": [],
        "text": [],
        "column": "divorceDt",
        "answer": "",
        "hide": false,
        "mailColumnNm": "사별/이혼한 날짜",
        "visible": {
            "column": "spouse",
            "value": [
                "사별",
                "이혼"
            ]
        }
    },
    {
        "step": 117,
        "type": 2,
        "title": "5) $stdYear$년 12월 31일 기준 세대주입니까?(주민등록등본상 세대주로 등록된 자)",
        "treeTitle": "세대주 여부",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "householderYn",
        "answer": "",
        "hide": false,
        "mailColumnNm": "세대주 여부",
    },
    {
        "step": 118,
        "type": 2,
        "title": `3) 한국 내 현재 주소를 입력하세요. ($stdYear$년 12월 31일 기준, 주민등록상 국내주소지)`,
        "treeTitle": "1 - 3) 주소",
        "questions": [],
        "text": [],
        "column": "roadAddr"
    },
    {
        "step": 119,
        "type": 2,
        "title": "3 - 5)  2026년 2월말까지 저축기관에 무주택확인서를 제출하였나요?<div style='color: #777; font-weight: normal; font-size: 16px; padding-left: 45px;'>(단, 무주택확인서는 1회 제출에 한하며 매년 제출할 필요는 없음) 동일한 저축에 대하여 1회라도 제출한 경우 \“예\”로 입력)</div>",
        "treeTitle": "",
        "questions": [],
        "text": [
            {
                "key": "1",
                "content": "예"
            },
            {
                "key": "0",
                "content": "아니오"
            }
        ],
        "column": "step_119",
        "answer": "",
        "hide": false,
        "mailColumnNm": "동 공제를 위해 공제과세기간 다음연도 2월말까지 저축기관에 무주택확인서를 제출하였음"
    },
  {
    "step": 120,
    "type": 2,
    "title": "4 - 2) $stdYear$년 1월 1일 - 12월31일 사이에 배우자와 혼인신고를 하였으며, $stdYear$년 12월 31일 기준 동 배우자와 혼인관계를 유지하고 계신지 확인해주십시오.",
    "treeTitle": "혼인유지여부",
    "questions": [],
    "text": [
      {
        "key": "1",
        "content": "예"
      },
      {
        "key": "0",
        "content": "아니오(2025년 이전에 혼인신고를 하였거나 현재 이혼/사별함)"
      }
    ],
    "column": "divorceYn",
    "answer": "",
    "hide": false,
    "mailColumnNm": "혼인관계 유지여부",
    "visible": {
      "column": "spouse",
      "value": [
        "사별",
        "이혼"
      ]
    }
  },
  {
    "step": 121,
    "type": 1,
    "title": "본인의 단독명의 주택임대 수입금액",
    "treeTitle": "2024년 본인의 단독명의 주택임대 수입금액",
    "questions": [],
    "text": [],
    "column": "preBizAmt",
    "answer": "",
    "hide": true
  },
  {
    "step": 122,
    "type": 1,
    "title": "본인을 포함한 공동명의 주택임대 수입금액(분배비율 안분 후 금액)",
    "treeTitle": "2024년 본인을 포함한 공동명의 주택임대 수입금액",
    "questions": [],
    "text": [],
    "column": "preBizAmt_01",
    "answer": "",
    "hide": true
  },
  {
    "step": 123,
    "type": 1,
    "title": "상가임대 수입금액",
    "treeTitle": "2024년 본인의 단독명의 상가임대 수입금액",
    "questions": [],
    "text": [],
    "column": "preBizAmt_02",
    "answer": "",
    "hide": true
  },
  {
    "step": 124,
    "type": 1,
    "title": "본인을 포함한 공동명의 상가임대 수입금액(분배비율 안분 후 금액)",
    "treeTitle": "2024년 본인을 포함한 공동명의 상가임대 수입금액",
    "questions": [],
    "text": [],
    "column": "preBizAmt_03",
    "answer": "",
    "hide": true
  },
  {
    "step": 125,
    "type": 2,
    "title": "4 - 1) $stdYear$년 1월 1일 - 12월31일 사이에 배우자와 혼인신고를 하였으며, 과거 결혼세액공제를 받은 적이 없는지 확인해주십시오.",
    "treeTitle": "결혼세액공제여부",
    "questions": [],
    "text": [
      {
        "key": "1",
        "content": "예"
      },
      {
        "key": "0",
        "content": "아니오"
      }
    ],
    "column": "marTaxYn",
    "answer": "",
    "hide": false,
    "mailColumnNm": "결혼세액공제여부",
    "visible": {
      "column": "spouse",
      "value": [
        "기혼"
      ]
    }
  },
  {
    "step": 126,
    "type": 2,
    "title": '가)    $stdYear$년 장기주택저당차입금의 이자납부기간동안 관련 담보 물건에 실제로 거주하고 있었습니까?',
    "treeTitle": "",
    "questions": ["일부 기간에만 거주한 경우, 관련 기간에 해당하는 이자납부내역만 조회하여 <a href='/survey#112' style='color: #26A9E3; padding-left: 6px'>질문10</a>에 업로드 부탁드립니다."],
    "text": [
      {
        "key": "1",
        "content": "예, 거주하고 있습니다."
      },
      {
        "key": "0",
        "content": "아니오, 거주하고 있지 않습니다."
      }
    ],
    "column": "step_126",
    "answer": "",
    "hide": false,
    "visible": {
      "column": "step_61",
      "value": "0"
    },
    "mailColumnNm": "2025년 이자 납부기간 동안 담보 물건에 실제 거주 여부"
  },
  {
    "step": 127,
    "type": 2,
    "title": "4 - 5)  근로자 본인은 2025년 12월 31일 기준 세대주의 배우자입니까?<div style='color: #777; font-weight: normal; font-size: 16px; padding-left: 45px;'>- 2025년 귀속 추가질문사항입니다.</div>",
    "treeTitle": "",
    "questions": [],
    "text": [
      {
        "key": "1",
        "content": "예"
      },
      {
        "key": "0",
        "content": "아니오"
      }
    ],
    "column": "step_127",
    "answer": "",
    "hide": false,
    "mailColumnNm": "세대주의 배우자여부"
  },
];

export default surveyData;

